import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
    applicantEnterpriseApplicationsRoute,
    employerApplicationsKey,
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetEnterpriseApplicantApplicationsProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    id?: number | null;
    company_id?: number | null;
    isEnterprise?: boolean
};

export const useGetEnterpriseApplicantApplications = ({
    setErrorText = () => { },
    id,
    isEnterprise,
    company_id
}: useGetEnterpriseApplicantApplicationsProps) => {
    const { data: enterpriseApplicantApplications } = useQuery({
        queryKey: [employerApplicationsKey, id, company_id],
        queryFn: () => {
            const params = new URLSearchParams();

            params.append('applicant_id', String(id));
            params.append('company_id', String(company_id));

            return axiosInstance
                .get(applicantEnterpriseApplicationsRoute, { params })
                .then((res) => res.data);
        },
        onSuccess: (data) => {
            if (data.object) {
                setErrorText('');
            }
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
        enabled: Boolean(id && isEnterprise),
    });

    return {
        enterpriseApplicantApplications,
    };
};
